
import {logger} from '../utils/logger.js';
class VideoMSERender {

    player;

    width;
    height;
    tag = 'VideoMSERender'

    constructor(player, video) {

        this.player = player;
        this.video = video;

        this.width = video.width;
        this.height = video.height;

    }

    setMediaSourceObjectUrl(objecturl) {

        this.video.src = objecturl;

        this.startPlayVideo()

        logger.info(this.tag, 'start MSE render in Main Thread');
    }


    setMediaSourceHandle(handle) {

        this.video.srcObject = handle;
        
        this.startPlayVideo()

        logger.info(this.tag, 'start MSE render in Worker Thread');
    }

    startPlayVideo() {


        this.video.play().then(()=>{


            logger.info(this.tag, 'video label start play');

        }).catch((e) =>{

            logger.info(this.tag, `video label start play err ${e}`);

        })
    }

    mute() {

        this.video.muted = true
    }


    unMute() {

        this.video.muted = false
    }
   
    setVolume(num){
        this.video.volume = num
    }
  
    destroy() {

        if (this.video) {
            this.video.pause();
            this.video.currentTime = 0;
            if (this.video.srcObject) {
                this.video.srcObject = null;
                this.video.removeAttribute('srcObject');
            }
            if (this.video.src) {
                this.video.src = '';
                this.video.removeAttribute('src');
            }
            try {
                this.video.load();
            } catch (e) {
                // ignore
            }
        }

        logger.info(this.tag, 'VideoMSERender destroy');

    }



}


export default VideoMSERender;